import * as actionTypes from "../ActionTypes";

// ✅ Save Gallery
export const saveGalleryRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_GALLERY_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveGallerySuccess = (data) => ({
  type: actionTypes.SAVE_GALLERY_SUCCESS,
  payload: data,
});

export const saveGalleryFailure = (error) => ({
  type: actionTypes.SAVE_GALLERY_FAILURE,
  payload: error,
});

// ✅ Read Gallery
export const readGalleryRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_GALLERY_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readGallerySuccess = (data) => ({
  type: actionTypes.READ_GALLERY_SUCCESS,
  payload: data,
});

export const readGalleryFailure = (error) => ({
  type: actionTypes.READ_GALLERY_FAILURE,
  payload: error,
});

// ✅ Delete Gallery
export const deleteGalleryRequest = (payload, callback) => ({
  type: actionTypes.DELETE_GALLERY_REQUEST,
  payload,
  callback,
});

export const deleteGallerySuccess = (data) => ({
  type: actionTypes.DELETE_GALLERY_SUCCESS,
  payload: data,
});

export const deleteGalleryFailure = (error) => ({
  type: actionTypes.DELETE_GALLERY_FAILURE,
  payload: error,
});

// ✅ Update Gallery Image
export const updateGalleryImageRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_GALLERY_IMAGE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateGalleryImageSuccess = (data) => ({
  type: actionTypes.UPDATE_GALLERY_IMAGE_SUCCESS,
  payload: data,
});

export const updateGalleryImageFailure = (error) => ({
  type: actionTypes.UPDATE_GALLERY_IMAGE_FAILURE,
  payload: error,
});
// ✅ Get Image Base64
export const getImageBase64Request = (url, callback) => ({
  type: actionTypes.GET_IMAGE_BASE64_REQUEST,
  payload: { url },
  callback,
});

export const getImageBase64Success = (data) => ({
  type: actionTypes.GET_IMAGE_BASE64_SUCCESS,
  payload: data,
});

export const getImageBase64Failure = (error) => ({
  type: actionTypes.GET_IMAGE_BASE64_FAILURE,
  payload: error,
});
